@use '@fukuri-admins/ui/layout' as *;

.cardListContainer {
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin-bottom: 30px;
  @media screen and (max-width: $TB) {
    margin-bottom: 1px;
  }
}

.card {
  padding: 16px 8px;
  background-color: background('Primary');
}

.cardRow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardDate {
  font-size: 13px;
  color: text('Disabled');
}

.cardAmount {
  font-size: 18px;
  font-weight: bold;
  color: text('High');
}

.emptyCardList {
  text-align: center;
  padding: 16px;
  color: text('Disabled');
}
